<script lang="ts">
  export let angle = 0;
  export let scale = 1;
  export let variant = 0;
</script>

<g class="bridge-glyph" class:bridge-glyph--raised={angle > 1} transform={`scale(${scale})`}>
  <path class="bridge-glyph__route-mask" d="M-46 0H46" />
  <path class="bridge-glyph__water" d="M-46 0H46" />
  <path class="bridge-glyph__route" d="M-46 0H46" />

  <g class="bridge-art__leaf bridge-glyph__leaf bridge-glyph__leaf--left" transform="scale(-1 1)">
    <g class="bridge-glyph__moving" data-pivot="-26,-1" transform={`rotate(${angle} 26 -1)`}>
      <path class="bridge-glyph__deck" d="M0 -8H26V-1H0Z" />
      <path class="bridge-glyph__truss" d="M1 -8L7 -17L13 -8L19 -17L25 -8" />
      <path class="bridge-glyph__rail" d="M1 -13H25" />
    </g>
  </g>
  <g class="bridge-art__leaf bridge-glyph__leaf bridge-glyph__leaf--right">
    <g class="bridge-glyph__moving" data-pivot="26,-1" transform={`rotate(${angle} 26 -1)`}>
      <path class="bridge-glyph__deck" d="M0 -8H26V-1H0Z" />
      <path class="bridge-glyph__truss" d="M1 -8L7 -17L13 -8L19 -17L25 -8" />
      <path class="bridge-glyph__rail" d="M1 -13H25" />
    </g>
  </g>

  <g class="bridge-glyph__fixed">
    <path class="bridge-glyph__approach" d="M-39 -8H-31M31 -8H39" />
    <path class="bridge-glyph__pier" d="M-33 -5H-22V18H-35V13H-33ZM22 -5H33V18H20V13H22Z" />
    <path class="bridge-glyph__footing" d="M-37 14H-19V20H-37ZM19 14H37V20H19Z" />

    {#if variant % 3 === 0}
      <path class="bridge-glyph__house" d="M-35 -20L-27.5 -27L-20 -20V-6H-35ZM20 -20L27.5 -27L35 -20V-6H20Z" />
      <path class="bridge-glyph__window" d="M-31 -18H-28V-13H-31ZM-26 -18H-23V-13H-26ZM24 -18H27V-13H24ZM29 -18H32V-13H29Z" />
    {:else if variant % 3 === 1}
      <path class="bridge-glyph__house" d="M-35 -22H-20V-6H-35ZM20 -22H35V-6H20Z" />
      <path class="bridge-glyph__roof" d="M-37 -25H-18V-22H-37ZM18 -25H37V-22H18Z" />
      <path class="bridge-glyph__window" d="M-31 -19H-28V-13H-31ZM-25 -19H-22V-13H-25ZM23 -19H26V-13H23ZM29 -19H32V-13H29Z" />
    {:else}
      <path class="bridge-glyph__house" d="M-34 -19V-9H-21V-19Q-27.5 -27 -34 -19ZM21 -19V-9H34V-19Q27.5 -27 21 -19Z" />
      <path class="bridge-glyph__window" d="M-30 -18H-25V-12H-30ZM25 -18H30V-12H25Z" />
    {/if}

    <path class="bridge-glyph__railing" d="M-39 -12V-8M-35 -12V-8M35 -12V-8M39 -12V-8" />
    <circle class="bridge-glyph__pivot" cx="-26" cy="-1" r="3.2" />
    <circle class="bridge-glyph__pivot" cx="26" cy="-1" r="3.2" />
  </g>
</g>
